import React from "react";
import Helmet from "../components/Helmet/Helmet";

const Contact = () => {
  return (
    <Helmet title="Contact">
      <div>Contact</div>
    </Helmet>
  );
};

export default Contact;
